import script from "./RequestDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDemo.vue?vue&type=script&setup=true&lang=js"

import "./RequestDemo.vue?vue&type=style&index=0&id=fa25ab62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa25ab62"]])

export default __exports__